export const featuresBind = [
  { name: 'conditioner', url: 'o-air' },
  { name: 'delivery', url: 'o-delivery' },
  { name: 'animals', url: 'o-pet' },
  { name: 'luggage', url: 'o-trunk' },
  { name: 'receipt', url: 'receipt' }
];



// WEBPACK FOOTER //
// ./src/app/config/features.ts